


















































import { BaseModule } from "@/store/base.module";
import { DalModule } from "@/store/dal.module";
import { Component, Vue } from "vue-property-decorator";
import MenuItem from "./MenuItem.vue";
import { QuestionareModule, QuestionareVuexModule } from "@/store/questionary.module";
import InfoQuestionary from "@/components/ui/InfoQuestionary.vue";

@Component({
  components: {
    MenuItem,
    InfoQuestionary,
  },
})
export default class MenuView extends Vue {

  get showQuestionareInfo() {
    return QuestionareModule.questionsList.length > 0;
  }

  get menuItems() {
    const items = [
      {
        name: ["account-list", "add-account"],
        tooltip: "account-list",
        path: "account-list",
      },
      { name: ["account-info"], tooltip: "account-info", path: "account-info" },
      { name: ["service-info"], tooltip: "service-info", path: "service-info" },
      { name: ["calculate"], tooltip: "calculate", path: "calculate" },
      { name: ["pays"], tooltip: "pays", path: "pays" },
      { name: ["invoices"], tooltip: "invoices", path: "invoices" },
      { name: ["requests"], tooltip: "requests", path: "requests" },
      { name: ["change-pwd"], tooltip: "change-pwd", path: "change-pwd" },
      { name: ["change-email"], tooltip: "change-email", path: "change-email" },
      {
        name: ["change-personal"],
        tooltip: "change-personal",
        path: "change-personal",
      },
    ];

    return items;
  }

  get isMobile() {
    const bps = ["sm", "xs"];
    return bps.includes(this.$vuetify.breakpoint.name);
  }

  async goTo(name: string) {
    if (name != "requests") {
      this.$router.push({
        name,
        params: {
          id: this.$route.params.id
            ? this.$route.params.id
            : DalModule.AccountId
            ? DalModule.AccountId
            : (null as any),
        },
      });
    } else {
      try {
        BaseModule.setLoadingStatus(true);
        const res = await DalModule.getLinkForOnline();
        window.open(res);
      } finally {
        BaseModule.setLoadingStatus(false);
      }
    }
  }
}
